module.exports = __webpack_public_path__ + "src/img/artist/indexpic01.jpg?7188593815e542a8e74d8035ddbda500";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic01.jpg
// module id = 128
// module chunks = 0